export default "__VITE_ASSET__CtJbnV$F__"